import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const InstagramReelsIcon: ComponentWithAs<'svg', IIconProps> = (
  props,
) => (
  <Icon
    data-testid="instagram-reels-icon"
    boxSize={8}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M13.6158 0.833374H6.3842C3.31576 0.833374 0.833336 3.31987 0.833336 6.38424V13.6158C0.833336 16.6802 3.31576 19.1667 6.3842 19.1667H13.6158C16.6802 19.1667 19.1667 16.6843 19.1667 13.6158V6.38424C19.1667 3.31987 16.6842 0.833374 13.6158 0.833374ZM17.9255 6.05461H14.3768L12.6961 2.05831H13.6117C15.8825 2.05831 17.7505 3.82043 17.9214 6.05054L17.9255 6.05461ZM8.97244 6.05461L7.29171 2.05831H11.3898L13.0664 6.05054H8.96837L8.97244 6.05461ZM5.99353 2.07866L7.66204 6.05461H2.07455C2.23326 3.95065 3.89771 2.26586 5.99353 2.07866ZM17.9377 13.6158C17.9377 16.0006 16.0006 17.9377 13.6158 17.9377H6.3842C3.99945 17.9377 2.06234 16.0006 2.06234 13.6158V7.27954H17.9377V13.6158ZM8.1219 15.3006V9.92068C8.1219 9.62361 8.47188 9.45269 8.72013 9.62361L12.3542 12.1508C12.6757 12.3746 12.6757 12.8386 12.3542 13.0624L8.70792 15.5896C8.46375 15.7605 8.1219 15.5896 8.1219 15.3006Z"
      fill="currentColor"
    />
  </Icon>
);
